import React, { Component } from 'react';
import { Table, Divider, Button, Icon, Popconfirm, Input} from 'antd';
import axios from 'axios';
import LeaveBalanceDialogForm from './LeaveBalanceForm';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';

const API_HOST_URL = process.env.REACT_APP_API_URL

class LeaveBalance extends Component{
  
  state = {
    datalist: [],
    leaveBalance: {},
    visible: false,
    requestType: '',
    searchText: ''
  }

  componentDidMount(){
    this.fetchData();
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => { this.searchInput = node; }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => record[dataIndex].firstName.toString().toLowerCase().includes(value.toLowerCase()) ||
    record[dataIndex].lastName.toString().toLowerCase().includes(value.toLowerCase()), 
    
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ),
  })

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  }


  columns = [
    {
      title: 'Leave Type',
      dataIndex: 'leaveType.leaveType',
      key: 'leaveType'
    },
    {
      title: 'Brought Forward',
      dataIndex: 'broughtForward',
      key: 'broughtForward'
    },
    {
      title: 'Total Used',
      dataIndex: 'totalUsed',
      key: 'totalUsed'
    },
    {
      title: 'Leave Balance',
      dataIndex: 'leaveBalance',
      key: 'leaveBalance'
    },
    {
      title: 'Employee',
      dataIndex: 'employee',
      key: 'employee',
      ...this.getColumnSearchProps('employee'),
      render: (record) => (
        <a>{(record !== null)? record.firstName + ' ' + record.lastName: ''}</a>
      )
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (record) => (
        <span>
        <a href="javascript:;" onClick={() => this.handleEdit(record)}><Icon type="edit" /></a>

        <Divider type="vertical" />

        {this.state.datalist.length >= 1
          ? (
            <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(record)}>
              <a href="javascript:;"><Icon type="delete" /></a>
            </Popconfirm>
          ) : null}
          </span>
      ),

    }
  ];

  fetchData = () => {
    axios.get(`${API_HOST_URL}/api/leave/leavebalance/?expand=employee&expand=leaveType`)
      .then(res => {
        this.setState({
          datalist: res.data
        })
      })
  }

  handleCreate = () => {
    const form = this.formRef.props.form;
    const requestType = this.state.requestType;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      switch( requestType ){
        case 'post':
            return axios.post(`${API_HOST_URL}/api/leave/leavebalance/`, 
            {
              broughtForward: values.broughtForward,
              leaveBalance: values.leaveBalance,
              totalUsed: values.totalUsed,
              leaveType: values.leaveType,
              employee: values.employee
            },
            {
              headers: {Authorization: 'Token ' + this.props.token}  
            })
            .then(res => {
              console.log(res)
              form.resetFields();
              this.setState({ visible: false });
              this.fetchData()
        })
            .catch(error => console.err(error));

        case 'put':
            return axios.put(`${API_HOST_URL}/api/leave/leavebalance/${this.state.leaveBalance.id}/`, 
              {
                broughtForward: values.broughtForward,  
                leaveBalance: values.leaveBalance,
                totalUsed: values.totalUsed,
                leaveType: values.leaveType,
                employee: values.employee
              } ,
              {
                headers: {Authorization: 'Token ' + this.props.token}
              }
              
              )
                .then(res => {
                  console.log(res)
                  form.resetFields();
                  this.setState({ visible: false });
                  this.fetchData()
            })
                .catch(error => console.err(error));
                
        default: return;
      }
    });
  }

  handleEdit = record => {
      this.setState({leaveBalance: record});
      this.showModal('put');
  }

  handleDelete = (record) => {
    const datalist = [...this.state.datalist];

    return axios.delete(`${API_HOST_URL}/api/leave/leavebalance/${record.id}/`)
                .then(res => {
                  console.log(res)

                  this.setState({ visible: false });
                  this.fetchData()
            })
                .catch(error => console.err(error));
  }

  showModal = (type) => {
    if( type === 'post'){
      //no data should be passed to dialog form
      this.setState({leaveBalance: {}});
    }
    
    this.setState({ visible: true, requestType: type });
  }
  
  handleCancel = () => {
    this.setState({ visible: false });
  }
  
  saveFormRef = (formRef) => {
    this.formRef = formRef;
  }
  
  render(){
        return(
          <div>
            {
              this.props.userPermissions.indexOf('add_leavebalance') > -1 ?
              <Button type="primary" onClick={() => this.showModal('post')}>Add Leave Balance</Button>
              : ''
            }

            {
              this.props.userPermissions.indexOf('view_leavebalance') > -1 ?
              <Table columns={this.columns} dataSource={this.state.datalist} rowKey="id" scroll={{ x: '100%' }}/>
              : 'You do not have rights to view Leave Balances. Please Contact your Administrator'
           }

            <LeaveBalanceDialogForm
              wrappedComponentRef={this.saveFormRef}
              visible={this.state.visible}
              onCancel={this.handleCancel}
              onCreate={this.handleCreate}
              data={this.state.leaveBalance}/>
        </div>
        );
    }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null,
    userPermissions: state.userPermissions,
    token: state.token
  }
}

export default connect(mapStateToProps, null)(LeaveBalance);
// export default LeaveBalance;
